export const DEFAULT_SIZE_X_WINDOW = window.innerWidth
export const DEFAULT_SIZE_Y_WINDOW = window.innerHeight
export const MIN_WIDTH_TO_MENU_START_EXPANDED = 1616
